import React from "react";
import { ReactComponent as SearchIcon } from "assets/icons/search_main.svg";
import { ReactComponent as OrganizerIcon } from "assets/icons/organizer.svg";
import { ReactComponent as DashboardIcon } from "assets/icons/dashboard.svg";
import { ReactComponent as SettingsIcon } from "assets/icons/settings.svg";
import { NavLink } from "react-router-dom";

const navItems = [
  { to: "/", Icon: SearchIcon, label: "Cerca" },
  { to: "/dashboard", Icon: DashboardIcon, label: "Dashboard" },
  { to: "/organizer", Icon: OrganizerIcon, label: "Organizer" },
  { to: "/settings", Icon: SettingsIcon, label: "Settings" },
];

const MobileBottomBar = () => {
  return (
    <div className="flex items-center cursor-pointer justify-around bg-white z-50 fixed bottom-0 w-full h-[70px] border-t-[1px] border-[#EAECF0] md:hidden">
      {navItems.map(({ to, Icon, label }, index) => (
        <NavLink key={index} to={to}>
          {({ isActive }) => (
            <div className="flex flex-col items-center">
              <div className="w-[35px] h-[35px] flex items-center justify-center">
                <Icon
                  width={index === 0 ? 22 : 25}
                  height={index === 0 ? 22 : 25}
                  className={isActive ? "text-primary" : ""}
                />
              </div>
              <h2
                className={`text-[10px] leading-[5px] font-medium ${
                  isActive ? "text-primary" : "text-[#525866]"
                }`}
              >
                {label}
              </h2>
            </div>
          )}
        </NavLink>
      ))}
    </div>
  );
};

export default MobileBottomBar;
